import dayjs from 'dayjs'

export const commonServerLogger = (level: 'info' | 'error' | 'warn', message: string, data?: Record<string, any>) => {
  const currentTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
  const formatMessage = `[${currentTime}] [${level.toUpperCase()}] ${message}`
  const jsonData = JSON.stringify(data)
  switch (level) {
    case 'info':
      console.info(formatMessage, jsonData)
      break
    case 'error':
      console.error(formatMessage, jsonData)
      break
    case 'warn':
      console.warn(formatMessage, jsonData)
      break
    default:
      console.info(formatMessage, jsonData)
      break
  }
}
